import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, List, Icon, Button, Header, Input } from 'semantic-ui-react';
import i18next from 'i18next';

import './DeliveriesEditListItem.scss';

class DeliveriesEditListItem extends Component {
    state = {
        tag: '',
        estimatedTime: '0',
        orderFee: '0',
        minimumOrderPrice: '0',
        companyMinimumOrderPrice: undefined
    };

    constructor(props) {
        super(props);

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentWillMount() {
        const { area } = this.props;

        this.setState({
            tag: area.tag,
            estimatedTime: area.estimatedTime,
            orderFee: area.orderFee,
            minimumOrderPrice: area.minimumOrderPrice,
            companyMinimumOrderPrice: area.companyMinimumOrderPrice
        });
    }

    handleInputChange(inputName, value) {
        this.setState({ [inputName]: value });
    }

    renderListItemActions() {
        const { area, saveDeliveryAreaEdit, cancelDeliveryAreaEdit } = this.props;

        return (
            <List.Content floated='right'>
                <Button color='blue' icon labelPosition='left' onClick={() => saveDeliveryAreaEdit({ ...this.state })}>
                    {i18next.t('save')}
                    <Icon name='save' />
                </Button>
                <Button negative icon labelPosition='right' onClick={() => cancelDeliveryAreaEdit(area.tag)}>
                    {i18next.t('cancel')}
                    <Icon name='cancel' />
                </Button>
            </List.Content>

        );
    }

    renderListItemData() {
        const { area } = this.props;

        return (
            <List.Content>
                <Header className='pi-deliveries-edit-list-item-header'>{area.tag}</Header>
                <Table basic='very' color='teal' verticalAlign='middle' celled collapsing definition>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell>{i18next.t('estimatedDeliveryTime')}</Table.Cell>
                            <Table.Cell>
                                <Input type='number' size='small' transparent
                                    onChange={(event, { value }) => this.handleInputChange('estimatedTime', value)}
                                    defaultValue={this.state.estimatedTime} />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>{i18next.t('deliveryOrderFee')}</Table.Cell>
                            <Table.Cell>
                                <Input type='number' size='small' transparent
                                    onChange={(event, { value }) => this.handleInputChange('orderFee', value)}
                                    defaultValue={this.state.orderFee} />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>{i18next.t('minimumDeliveryOrderPrice')}</Table.Cell>
                            <Table.Cell>
                                <Input type='number' size='small' transparent
                                    onChange={(event, { value }) => this.handleInputChange('minimumOrderPrice', value)}
                                    defaultValue={this.state.minimumOrderPrice} />
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell>{i18next.t('minimumCompanyDeliveryOrderPrice')}</Table.Cell>
                            <Table.Cell>
                                <Input type='number' size='small' transparent
                                    onChange={(event, { value }) => this.handleInputChange('companyMinimumOrderPrice', value)}
                                    defaultValue={this.state.companyMinimumOrderPrice} />
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </List.Content>
        );
    }

    render() {
        return (
            <List.Item className='pi-deliveries-edit-list-item'>
                {this.renderListItemActions()}
                {this.renderListItemData()}
            </List.Item>
        );
    }

}

DeliveriesEditListItem.propTypes = {
    area: PropTypes.object,
    currencyCode: PropTypes.string,
    saveDeliveryAreaEdit: PropTypes.func,
    cancelDeliveryAreaEdit: PropTypes.func,
    
};

export default DeliveriesEditListItem;
